export default __webpack_public_path__ + "static/media/usdp.371be1ec.svg";